module.exports = __webpack_public_path__ + "img/question.8589239b.svg";